/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-status-checkmark-outline': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm-1.25-4.063l-3.125-3.1.994-.98 2.131 2.112 4.631-4.594.994.987-5.625 5.575z"/>'
  }
})
